// extracted by mini-css-extract-plugin
module.exports = {"searchbar":"SearchBar_searchbar__3suXv","geo":"SearchBar_geo__3s3fo","categories":"SearchBar_categories__3YdNP"};